import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtData } from "@/components/excelVoce/format";
import { AZIONE_SAL } from "./labels";

const Valori = ({ v }) => (v ? <span className="text-slate-500">{Object.entries(v).filter(([, x]) => x !== null && x !== "").map(([k, x]) => `${k}: ${x}`).join(" · ")}</span> : null);

export const StoricoSal = ({ kid, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/sal-contratti/${kid}/storico`).then((r) => setRows(r.data)); }, [kid]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="sal-storico-dialog">
        <DialogHeader><DialogTitle>Storico del rapporto</DialogTitle></DialogHeader>
        {!rows ? <p className="text-sm text-slate-500">Caricamento…</p> : (
          <ul className="space-y-2">{rows.map((h) => (
            <li key={h.id} className="border-b pb-2 text-xs" data-testid={`sal-storico-${h.id}`}>
              <div><b>{AZIONE_SAL[h.azione] || h.azione}</b> · {h.autore} · {fmtData(h.data)}</div>
              <div className="mt-0.5 break-words"><Valori v={h.dopo} /></div>
            </li>))}
          </ul>)}
      </DialogContent>
    </Dialog>
  );
};
